import { useQueries, UseQueryResult } from '@tanstack/react-query';

import { getHistoryCheckMOIdsFilter } from '@api/hitoryCheck';

import { fieldsOptionsFormatted } from '@utils/formatter';

import { IMoTreeFilters } from '@interfaces/cmModule/cmModule';
import { TMoNamesWithComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';

import { CONSISTENCY_DETAILS_MO_FILTERS } from '@constants/queryKeys';

interface UseQueryHistoryCheckMoFilterReturnType {
	isLoadingDetailsMoFilters: boolean;
	detailsMoFilters: IMoTreeFilters[];
}

const useQueryHistoryCheckMoFilter = (
	params: TMoNamesWithComparisonId,
): UseQueryHistoryCheckMoFilterReturnType => {
	const { moNames, comparisonId } = params;

	const moIds = useQueries({
		queries: moNames.map((moName) => ({
			queryKey: [CONSISTENCY_DETAILS_MO_FILTERS, moName, comparisonId],
			queryFn: () => getHistoryCheckMOIdsFilter({ moName, comparisonId }),
			enabled: !!moName.length,
			staleTime: Infinity,
		})),
	});

	return {
		isLoadingDetailsMoFilters:
			moIds.some((result: UseQueryResult<string[]>) => result.isInitialLoading || result.isFetching),
		detailsMoFilters: moIds.map((result: UseQueryResult<string[]>, index) => ({
			moName: moNames[index],
			data: fieldsOptionsFormatted(result.data || [])
				.map((option) => ({
					...option,
					name: moNames[index],
				})),
		})),
	};
};

export default useQueryHistoryCheckMoFilter;
